import LazyCellController from './lazy_cell_controller'

// A value-only measurement cell on the task Results grid
// (jobs/v2_sample_result_field_values/_inline_form). It works exactly like
// lazy-cell. The identifier is its own because a page still running a bundle
// from before these cells existed has a lazy-cell controller that only knows
// trait cells: with this name, such a page leaves the cells alone (no click
// handler, and its navigation and paste treat them as not editable) instead
// of blanking them.
export default class extends LazyCellController {}
